import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Landmark } from "lucide-react";
import { useApp } from "../context/AppContext";

export function Footer() {
  const { t, site } = useApp();
  return (
    <footer className="bg-slate-900 text-slate-300 mt-16" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 py-12 grid gap-10 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="w-8 h-8 rounded-lg bg-primary text-white flex items-center justify-center"><Landmark size={16} /></span>
            <span className="font-display font-bold text-lg text-white">DocGalaxy</span>
          </div>
          <p className="text-sm text-slate-400">{t("footer_tagline")}</p>
          <p className="text-xs text-slate-500 mt-4 leading-relaxed">{t("disclaimer_text")}</p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3 text-sm">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-white" data-testid="footer-about">{t("about")}</Link></li>
            <li><Link to="/services" className="hover:text-white" data-testid="footer-services">{t("services")}</Link></li>
            <li><Link to="/blog" className="hover:text-white" data-testid="footer-blog">{t("blog")}</Link></li>
            <li><Link to="/faq" className="hover:text-white" data-testid="footer-faq">{t("faq")}</Link></li>
            <li><Link to="/contact" className="hover:text-white" data-testid="footer-contact">{t("contact")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3 text-sm">Legal</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">{t("privacy")}</Link></li>
            <li><Link to="/terms" className="hover:text-white" data-testid="footer-terms">{t("terms")}</Link></li>
            <li><Link to="/refund-policy" className="hover:text-white" data-testid="footer-refund">{t("refund")}</Link></li>
            <li><Link to="/disclaimer" className="hover:text-white" data-testid="footer-disclaimer">{t("disclaimer")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3 text-sm">{t("contact")}</h4>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2"><Phone size={14} /> {site.phone}</li>
            <li className="flex items-center gap-2"><Mail size={14} /> {site.email}</li>
            <li className="flex items-start gap-2"><MapPin size={14} className="mt-1 shrink-0" /> <span>{site.address}</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-4 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} DocGalaxy Gujarat Property Services. Private assistance platform — not a government website.
      </div>
    </footer>
  );
}
